import styled from 'styled-components'

import aiRationaleBg from '@images/ai-rationale-bg.jpg'

export const BannerRoot = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-radius: 0.5rem;

  /* Holographic mesh-gradient image fill with a #231195 @ 10% overlay on top —
     the exact two-layer composition from the Figma design (node 6473-6431). */
  background-image: linear-gradient(rgb(35 17 149 / 10%), rgb(35 17 149 / 10%)),
    url(${aiRationaleBg});
  background-size: cover;
  background-position: center;
  color: ${({ theme }) => theme.whiteColor};
  font-family: Rubik, verdana, sans-serif;
  font-size: 0.875rem;
  line-height: 1.4;
`

// Score = "PROD-Desktop/Reg/H2 Header" per Figma 6473-6431: plain white Rubik
// 24px/32px, weight 400, 0.3px tracking — no pill/background.
export const BannerScore = styled.span`
  flex-shrink: 0;
  color: ${({ theme }) => theme.whiteColor};
  font-family: Rubik, verdana, sans-serif;
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 2rem;
  letter-spacing: 0.3px;
`

export const BannerText = styled.span`
  flex: 1;
`

export const BannerSparkle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
`
